import Vue from 'vue'
import Router from 'vue-router'
import {getLoginUser} from '../util/common'

const _import = require('./_import_' + process.env.NODE_ENV)

const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error)
}

Vue.use(Router)

const router = new Router({
  // mode: 'hash',
  scrollBehavior: () => ({y: 0}),
  routes: [{
    path: '/',
    name: 'main',
    redirect: '/home',
    meta: {title: '互联制造BESTIMADE', login: false},
    component: _import('main/index'),
    children: [{
      path: '/home',
      name: 'home',
      meta: {title: '首页', login: false},
      component: _import('home/index')
    }, {
      path: '/company',
      name: 'company',
      meta: {title: '企业资源', login: false},
      component: _import('company/list')
    }, {
      path: '/company/detail/:companyKey',
      name: 'company-detail',
      meta: {title: '企业资源详情', login: false},
      component: _import('company/detail')
    }, {
      path: '/demand',
      name: 'demand',
      meta: {title: '采购需求', login: false},
      component: _import('demand/list')
    }, {
      path: '/demand/detail/:id',
      name: 'demand-detail',
      meta: {title: '需求详情', login: false},
      component: _import('demand/detail')
    }, {
      path: '/supply',
      name: 'supply',
      meta: {title: '供应资源', login: false},
      component: _import('supply/list')
    }, {
      path: '/supply/detail/:id',
      name: 'supply-detail',
      meta: {title: '资源详情', login: false},
      component: _import('supply/detail')
    }, {
      path: '/case',
      name: 'case',
      meta: {title: '成功案例', login: false},
      component: _import('case/list')
    }, {
      path: '/user',
      name: 'user',
      meta: {title: '个人中心', login: true},
      component: _import('user/index')
    }, {
      path: '/login',
      name: 'login',
      meta: {title: '登录', login: false},
      component: _import('login/login')
    }, {
      path: '/reset-password',
      name: 'reset-password',
      meta: {title: '注册', login: false},
      component: _import('login/reset-password')
    }, {
      path: '/register',
      name: 'register',
      meta: {title: '找回密码', login: false},
      component: _import('login/register')
    }, {
      path: '/about',
      name: 'about',
      meta: {title: '关于我们', login: false},
      component: _import('home/about')
    }]
  }, {
    path: '/privacy',
    name: 'privacy',
    meta: {title: '隐私策略', login: false},
    component: _import('main/privacy')
  }]
})

function isMobile() {
  let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
  return flag
}

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  let loginUser = getLoginUser()
  if (to.meta.login === true && loginUser == null) {
    next({name: 'login'})
    return
  }
  if (isMobile() && to.name !== 'privacy') {
    window.location.href = 'https://www.bestimade.com/appDownload.html'
  }
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js